import Banners from '@/views/MarketingMaterials/Banners/Banners.vue';
import MonthlyPaymentCalculator from '@/views/MarketingMaterials/MonthlyPaymentCalculator.vue';
import Flyer from '@/views/MarketingMaterials/Flyer.vue';
import FullPageWidget from '@/views/MarketingMaterials/FullPageWidget.vue';
import RealWidget from '@/views/MarketingMaterials/RealWidget.vue';
import InvoiceEstimate from '@/views/MarketingMaterials/InvoiceEstimate/InvoiceEstimate.vue';
import Users from '@/views/Manage/Users/Users.vue';
import Main from '@/views/Main.vue';
import CardPayments from '@/views/CardPayments.vue';
import CoBrandedPage from '@/views/CoBrandedPage/CoBrandedPage.vue';
import PersonalInfo from '@/views/PersonalInfo.vue';
import Login from '@/views/Login.vue';
import ClosedAccount from '@/views/ClosedAccount.vue';
import RestorePassword from '@/views/RestorePassword.vue';
import ConfirmChangePassword from '@/views/ConfirmChangePassword.vue';
import ConfirmChangeEmail from '@/views/ConfirmChangeEmail.vue';
import ConfirmAccount from '@/views/ConfirmAccount.vue';
import PayoutTax from '@/views/PayoutTax.vue';
import ReportsApplications from '@/views/ReportsApplications.vue';
import ReportsCommissions from '@/views/ReportsCommissions/ReportsCommissions.vue';
import ManageEmails from '@/views/ManageEmails.vue';
import ManagePlans from '@/views/Manage/Plans/Plans.vue';
import Settings from '@/views/Manage/Settings/Settings.vue';
import SocialMediaImages from '@/views/MarketingMaterials/SocialMediaImages.vue';
import Refer from '@/views/Refer.vue';
import TrainingAndFaqs from '@/views/TrainingAndFaqs.vue';
import CardPaymentAcceptance from '@/views/CardPaymentAcceptance.vue';

export default [
  {
    path: '/',
    name: 'main',
    component: Main,
  },
  {
    path: '/personal-info',
    name: 'personal-info',
    component: PersonalInfo,
  },
  {
    path: '/payout-tax',
    name: 'payout-tax',
    component: PayoutTax,
  },
  {
    path: '/manage/users',
    name: 'manage-users',
    component: Users,
  },
  {
    path: '/manage/emails',
    name: 'manage-emails',
    component: ManageEmails,
  },
  {
    path: '/manage/plans',
    name: 'manage-plans',
    component: ManagePlans,
  },
  {
    path: '/manage/settings',
    name: 'manage-settings',
    component: Settings,
  },
  {
    path: '/reports-applications',
    name: 'reports-applications',
    component: ReportsApplications,
    props: true,
  },
  {
    path: '/reports-commissions',
    name: 'reports-commissions',
    component: ReportsCommissions,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/closed-account',
    name: 'Closed Account',
    component: ClosedAccount,
  },
  {
    path: '/restore',
    name: 'Restore',
    component: RestorePassword,
    props: true,
  },
  {
    path: '/np',
    name: 'New password',
    component: ConfirmChangePassword,
  },
  {
    path: '/ne',
    name: 'Change email',
    component: ConfirmChangeEmail,
  },
  {
    path: '/confirm',
    name: 'Confirm account',
    component: ConfirmAccount,
  },
  {
    path: '/card-payments',
    name: 'card-payments',
    component: CardPayments,
  },
  {
    path: '/co-branded',
    name: 'co-branded',
    component: CoBrandedPage,
  },
  {
    path: '/social-media-images',
    name: 'social-media-images',
    meta: { resource: 'marketing-materials' },
    component: SocialMediaImages,
  },
  {
    path: '/banners',
    name: 'banners',
    meta: { resource: 'marketing-materials' },
    component: Banners,
  },
  {
    path: '/monthly-payment-calculator',
    name: 'monthly-payment-calculator',
    meta: { resource: 'marketing-materials' },
    component: MonthlyPaymentCalculator,
  },
  {
    path: '/flyer',
    name: 'flyer',
    meta: { resource: 'marketing-materials' },
    component: Flyer,
  },
  {
    path: '/homeowner-flyer',
    redirect: { name: 'flyer' },
  },
  {
    path: '/full-page-widget',
    name: 'full-page-widget',
    meta: { resource: 'marketing-materials' },
    component: FullPageWidget,
  },
  {
    path: '/real-widget',
    name: 'real-widget',
    meta: { resource: 'marketing-materials' },
    component: RealWidget,
  },
  {
    path: '/invoice-estimate',
    name: 'invoice-estimate',
    meta: { resource: 'marketing-materials' },
    component: InvoiceEstimate,
  },
  {
    path: '/refer',
    name: 'refer',
    component: Refer,
  },
  {
    path: '/training-and-faqs',
    name: 'training-and-faqs',
    component: TrainingAndFaqs,
  },
  {
    path: '/card-payment-acceptance',
    name: 'card-payment-acceptance',
    component: CardPaymentAcceptance,
  },
];
